// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2itKG","content":"Consent_content__2p8Nq","footer":"Consent_footer__34sC2"};